import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AdminService } from 'src/app/services/admin/admin.service';
import { ToastrService } from 'ngx-toastr';
import { index } from 'src/app/models/index';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from 'src/app/components/layout/spinner/spinner.component';
import { SeandComponent } from '../../auth/verify/seand/seand.component';

@Component({
  selector: 'app-change-my-info',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    SpinnerComponent,
    SeandComponent
  ],
  templateUrl: './change-my-info.component.html',
  styleUrls: ['./change-my-info.component.css']
})
export class ChangeMyInfoComponent implements OnInit{

  form: FormGroup
  error: any
  isLoading = false

  indexPhone = index;
  selectedCountryName: string = '';
  showFullIndex: boolean = false;
  isVerificationSent = false;
  isVerificationSuccessful = false;
  timer: number = 180;
  timerInterval: any;

  data: any
  loadInfo = false

  loadSave = false
  selectedLanguage: string = '';

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    private toastr: ToastrService,
    private languageService: LanguagesService
  ){
    this.languageService.selectedLanguage$.subscribe(
      (lang: any) => {this.selectedLanguage = lang?.code}
    );
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      phone: [null, Validators.required],
      index: [null, Validators.required],
      email: ['', Validators.required],
      lang: this.selectedLanguage
    });
    this.loadData();
  }

  loadData(): void {
    this.loadInfo = true
    this.adminService.getMyInfo().subscribe(
      (res: any) => {
        this.loadInfo = false
        this.data = res;
        this.updateForm();
        console.log(this.data)
      },
      (error: any) => {
        this.loadInfo = false
      }
    );
  }

  updateForm(): void {
    if (this.data) {
      this.form.patchValue({
        name: this.data.name,
        lastname: this.data.lastname,
        phone: this.data.phone,
        index: this.data.index || '+995',
        email: this.data.email,
      });
    }
  }

  onIndexChange(event: any): void {
    const selectedIndex = event.target.value;
    this.setSelectedCountryName(selectedIndex);
  }

  setSelectedCountryName(index: string): void {
    const selectedCountry = this.indexPhone.find(item => item.index === index);
    this.selectedCountryName = selectedCountry ? selectedCountry.name : 'sity';
  }

  showRules(){
    return true;
  }

  changeInfo(){
    this.loadSave = true
    
    this.adminService.changeUserInfo(this.form.value).subscribe(
      (res: any) => {
        // console.log(res)
        this.loadData();
        this.loadSave = false
        
      },
      (error: any) => {
        // console.log(error)
        this.loadSave = false
      }
    )
  }

}
